import { render, staticRenderFns } from "./customers-add-or-update.vue?vue&type=template&id=bffe030a&"
import script from "./customers-add-or-update.vue?vue&type=script&lang=js&"
export * from "./customers-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports